import React, { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { useAppearance } from '../theme/AppearanceProvider';
import useGlassPanel from '../theme/glassPanel';

// The frosted-glass panel with a glowing brand-green top edge that wraps a grid
// on the Aurora skin — DocumentGridShell and the bespoke list pages (Users,
// Customers, Items) all render this same surface (item 406: the shell's former
// inline copy is gone; this is the only definition).
// In the Accountant skin (item 61) it becomes a flat, solid, undecorated panel.
const GlassGridPanel: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { aurora } = useAppearance();
  const glass = useGlassPanel();
  return (
    <Box
      {...glass}
      position="relative"
      overflow="hidden"
      p={{ base: 3, md: 5 }}
    >
      {aurora && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          h="2px"
          bgGradient="linear(to-r, transparent, brandGreen.400, transparent)"
          boxShadow="0 0 14px var(--chakra-colors-brandGreen-400)"
        />
      )}
      {children}
    </Box>
  );
};

export default GlassGridPanel;
